import { connect } from "react-redux";
import UserDucks from "stores/ducks/User.duck";

interface IOnlyLoggedInProps {
  children?: any;
  isLoggedIn: boolean;
  eventId?: string;
  // Role related informations
  isAdmin: boolean;
  isEventHost: boolean;
  isEventPromoter: boolean;
  isEventChecker: boolean;
  // Global role related informations
  isEventHostSomewhere: boolean;
  isEventPromoterSomewhere: boolean;
  isEventCheckerSomewhere: boolean;
  // Who have to get access ?
  checkPromoter: boolean;
  checkChecker: boolean;
  checkHost: boolean;
}

interface IProtectedContainerProps {
  eventId?: string;
  event?: object;
  promoter?: boolean;
  checker?: boolean;
  host?: boolean;
  children?: any;
}

/**
 * used for hiding / showing only for certain role
 *
 * @todo need to cover with Tests
 * @param props IOnlyLoggedInProps
 */
const ProtectedContainer = (props: IOnlyLoggedInProps) => {
  const { isLoggedIn } = props;
  const { children } = props;


  // First -- Is user logged in ?
  if (!isLoggedIn) {
    return null;
  }

  // Then if user is admin - there is no higher role.
  if (props.isAdmin) {
    return children;
  }

  // Check if we want to allow another role(s)
  if (!props.checkHost && !props.checkPromoter && !props.checkChecker) {
    return null;
  }

  // Check if eventId is provided,
  // Then check descending of role level -> host, promoter, checker
  if (props.eventId) {
    // If host only access...
    if (props.checkHost && props.isEventHost){
      return children;
    }
    // If promoter only access...
    if (props.checkPromoter) {
      // only promoter and event host allowed
      if (props.isEventPromoter || props.isEventHost) {
        return children;
      }
    }
    // If checker only access...
    if (props.checkChecker) {
      // only checker and host allowed
      if (props.isEventChecker || props.isEventHost) {
        return children;
      }
    }
    // Otherwise we want to know if user have somewhere role(s)
    // which are required for access
  } else {
    // If host only access...
    if (props.isEventHostSomewhere) {
      return children;
    }
    // If promoter only access...
    if (props.checkPromoter) {
      // only promoter and event host allowed
      if (props.isEventPromoterSomewhere) {
        return children;
      }
    }
    // If checker only access...
    if (props.checkChecker) {
      if (props.isEventCheckerSomewhere) {
        return children;
      }
    }
  }
  return null;
};

const mapStateToProps = (state, ownProps: IProtectedContainerProps) => {
  return {

    isLoggedIn: UserDucks.isAuthenticated(state),

    isAdmin: UserDucks.isAdmin(state),

    eventId: ownProps.eventId,


    isEventHost: UserDucks.isEventHost(state, ownProps.eventId),
    isEventHostSomewhere: UserDucks.isEventHostSomewhere(state),

    isEventPromoter: UserDucks.isEventPromoter(state, ownProps.eventId),
    isEventPromoterSomewhere: UserDucks.isEventPromoterSomewhere(state),

    isEventChecker: UserDucks.isEventChecker(state, ownProps.eventId),
    isEventCheckerSomewhere: UserDucks.isEventCheckerSomewhere(state),


    checkHost: ownProps.host || false,
    checkPromoter: ownProps.promoter || false,
    checkChecker: ownProps.checker || false
  };
};

export default connect(mapStateToProps)(ProtectedContainer);



// WEBPACK FOOTER //
// ./src/components/guards/ProtectedContainer.tsx